<button class="btn" (click)="onClick($event)">
  <svg-icon src="/assets/icons/add.svg"></svg-icon>
  Add one more application
</button>
